import deepcopy from 'deepcopy';

const configuration = require('../../../data/config.json');

const config = (state = configuration, action) => {
	switch (action.type) {
		default:
			return state;
	}
};

import { ASYNC, ASYNC_ACTIONS, MEME, MEME_ACTIONS } from './models';

const async = (state = ASYNC, action) => {
	switch (action.type) {
		case ASYNC_ACTIONS.SET_PROGRESS:
			return { ...state, inProgress: action.progress };
		default:
			return state;
	}
};

const createSetProgressAction = progress => ({
	type: ASYNC_ACTIONS.SET_PROGRESS,
	progress,
});

const asyncActionCreators = {
	createSetProgressAction,
};

const meme = (state = MEME, action) => {
	//console.log('meme(), action.type:', action.type);
	switch (action.type) {
		case MEME_ACTIONS.SET_OFFSET:
			return { ...state, offset: action.offset, saved: false };
		case MEME_ACTIONS.SET_SAVED:
			return { ...state, saved: action.saved };
		case MEME_ACTIONS.SET_CONFIG:
			return { ...state, images: images(state.images, action), fields: action.fields };
		case MEME_ACTIONS.SET_USER_IMAGE:
			return { ...state, images: images(state.images, action), rotation: 0, offset: 0, saved: false };
		case MEME_ACTIONS.ROTATE_USER_IMAGE:
			return { ...state, rotation: action.rotation, saved: false };
		case MEME_ACTIONS.SET_TEXT: {
			const copyFields = deepcopy(state.fields);
			copyFields[action.index].text = action.text;
			return { ...state, fields: copyFields, saved: false };
		}
		default:
			return state;
	}
};

const images = (state = MEME.images, action) => {
	// console.group('----------------------------------');
	// console.info('images(), action:', action);
	// console.groupEnd();
	switch (action.type) {
		case MEME_ACTIONS.SET_CONFIG:
			return { ...state, default: action.images.default, overlay: action.images.overlay };
		case MEME_ACTIONS.SET_USER_IMAGE:
			return { ...state, user: action.image };
		default:
			return state;
	}
};

const createSetConfigAction = (images, fields) => ({
	type: MEME_ACTIONS.SET_CONFIG,
	images,
	fields,
});

const createSetSavedAction = saved => ({
	type: MEME_ACTIONS.SET_SAVED,
	saved,
});

const createSetOffsetAction = offset => ({
	type: MEME_ACTIONS.SET_OFFSET,
	offset,
});

const createSetUserImageAction = image => ({
	type: MEME_ACTIONS.SET_USER_IMAGE,
	image,
});

const createSetUserImageRotationAction = rotation => ({
	type: MEME_ACTIONS.ROTATE_USER_IMAGE,
	rotation,
});

const createSetTextAction = (index, text) => ({
	type: MEME_ACTIONS.SET_TEXT,
	index,
	text,
});

const memeActionCreators = {
	createSetConfigAction,
	createSetSavedAction,
	createSetUserImageAction,
	createSetUserImageRotationAction,
	createSetTextAction,
	createSetOffsetAction,
};

// Action Change Reducer:
let previousAction = undefined;
const actionChange = (state = null, action) => {
	const result = {
		previousAction: { ...previousAction },
		currentAction: { ...action },
	};
	previousAction = action;
	return result;
};

export { config, configuration, async, asyncActionCreators, actionChange, meme, memeActionCreators };



// WEBPACK FOOTER //
// ./src/js/components/model/modelReducers.js